import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from 'react-loading';
import { Form } from 'semantic-ui-react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { useMutation } from '@apollo/react-hooks';
import { Main, Button, Send } from './styles';
import { MdSend } from 'react-icons/md';
import { toast } from 'react-toastify';

import {
  ADD_TELEGRAM_GROUPS,
  UPDATE_TELEGRAM_GROUPS
} from '../../../services/graphql/mutations';

import { schema, formInitialState, formErrorInitialState } from './constants';

export default function Modal({
  edit,
  onClose,
  selectedValue,
  open,
  mallsOptions,
  selected = {}
}) {
  const [{ group_id, group_name, mall_id, active }, setFormState] = useState(
    formInitialState
  );
  const [
    { group_idError, group_nameError, mall_idError, activeError },
    setFormErrorState
  ] = useState(formErrorInitialState);

  const [addTelegramGroup, { loading: addLoading }] = useMutation(
    ADD_TELEGRAM_GROUPS
  );
  const [updateTelegramGroup, { loading: updateLoading }] = useMutation(
    UPDATE_TELEGRAM_GROUPS
  );

  useEffect(() => {
    if (open) {
      setFormState(formInitialState);
      setFormErrorState(formErrorInitialState);
    }

    if (edit && open) {
      const { group_id, group_name, mall_id, active } = selected;

      setFormState({
        group_id,
        group_name,
        mall_id,
        active
      });
    }
  }, [open, edit, selected]);

  function handleOnChange(name, value) {
    setFormState(prevState => ({ ...prevState, [name]: value }));
  }

  async function handleSubmit() {
    try {
      setFormErrorState(formErrorInitialState);

      await schema.validate(
        { group_id, group_name, mall_id, active },
        { abortEarly: false }
      );

      if (edit) {
        const editTelegramInput = {
          id: selected.id,
          group_id,
          group_name,
          mall_id,
          active
        };

        await updateTelegramGroup({
          variables: {
            editTelegramInput
          }
        });
      } else {
        const telegramInput = {
          group_id,
          group_name,
          mall_id,
          active
        };

        await addTelegramGroup({
          variables: {
            telegramInput
          }
        });
      }

      setFormState(formInitialState);

      let successMessage;

      if (edit) successMessage = 'El registro fue editado exitosamente';
      else successMessage = 'El registro fue creado exitosamente';

      toast.success(successMessage);

      handleClose();
    } catch (err) {
      if (err.inner) {
        err.inner.map(error =>
          setFormErrorState(prevState => ({
            ...prevState,
            [`${error.path}Error`]: true
          }))
        );
      } else {
        let errorMessage;

        if (edit) errorMessage = 'Error al intentar actualizar el registro';
        else errorMessage = 'Error al intentar crear el registro';

        toast.error(errorMessage);
      }
    }
  }

  function handleClose() {
    onClose(selectedValue);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        {edit ? 'Editar' : 'Ingresar'} Grupo Telegram
      </DialogTitle>
      <Main data-testid="modal-component">
        <Form>
          <Form.Group>
            <Form.Input
              error={group_idError}
              label="Group ID *"
              placeholder="Group ID"
              width={4}
              value={group_id}
              onChange={(e, { value }) => handleOnChange('group_id', value)}
              className="plateInput"
            />
            <Form.Input
              error={group_nameError}
              label="Group Name *"
              placeholder="Group Name"
              width={4}
              value={group_name}
              onChange={(e, { value }) => handleOnChange('group_name', value)}
              className="plateInput"
            />
            <Form.Select
              error={mall_idError}
              label="Centro Comercial *"
              placeholder="Seleccione Mall"
              options={mallsOptions}
              width={6}
              value={mall_id}
              onChange={(e, { value }) => handleOnChange('mall_id', value)}
              aria-expanded="false"
            />
          </Form.Group>
          <Form.Group>
            <Form.Checkbox
              error={activeError}
              label="Activo"
              width={2}
              onClick={() => handleOnChange('active', !active)}
              checked={active}
              placeholder="activo"
            />
          </Form.Group>
        </Form>
        <Button onClick={handleSubmit} data-testid="send-button">
          {addLoading || updateLoading ? (
            <Loading height={15} width={15} type="spin" />
          ) : (
            <Send>
              <MdSend />
              Enviar
            </Send>
          )}
        </Button>
      </Main>
    </Dialog>
  );
}

Modal.propTypes = {
  edit: PropTypes.bool,
  onClose: PropTypes.func,
  selectedValue: PropTypes.any,
  open: PropTypes.bool,
  selected: PropTypes.object,
  mallsOptions: PropTypes.array.isRequired
};
